import { MUTINY } from '../constants';
import { fetchWithTimeout } from './fetch-with-timeout';
import { getCookie } from './get-cookie';

export const authedFetch = async (
  tenant: string,
  url: string,
  settings: RequestInit,
  tokenOverride: string,
  headers?: HeadersInit,
  timeout?: number
): Promise<Response> => {
  const token: string = tokenOverride;

  const defaultSettings: RequestInit = {
    method: 'GET',
    headers: new Headers({
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
      'ngrok-skip-browser-warning': 'true',
      'X-SOCKET-ID': localStorage?.getItem('WEBSOCKET:SESSIONID') || '',
      'X-SESSION-ID': getCookie('P2G.Session.Id'),
      'x-mutiny': MUTINY,
      'x-tenant': tenant,
      ...(headers || {})
    })
  };

  const combinedSettings: RequestInit = { ...defaultSettings, ...settings };
  if (timeout) {
    return fetchWithTimeout(url, combinedSettings, timeout);
  }

  return fetch(url, combinedSettings);
};
export const authedFileFetch = async (
  url: string,
  settings: RequestInit,
  tokenOverride: string,
  headers?: HeadersInit,
  timeout?: number
): Promise<Response> => {
  const token: string = tokenOverride;

  const defaultSettings: RequestInit = {
    method: 'GET',
    headers: new Headers({
      Authorization: 'Bearer ' + token,
      'X-SOCKET-ID': localStorage?.getItem('WEBSOCKET:SESSIONID') || '',
      'X-SESSION-ID': getCookie('P2G.Session.Id'),
      'x-mutiny': MUTINY,
      ...(headers || {})
    })
  };

  const combinedSettings: RequestInit = { ...defaultSettings, ...settings };
  if (timeout) {
    return fetchWithTimeout(url, combinedSettings, timeout);
  }

  return fetch(url, combinedSettings);
};
